/*-----------------------------------------------------------------
- Breadcrumbs translations
-----------------------------------------------------------------*/
export default {
    
    fluorocarbon: {
        calendar: 'Consultations',
    },
    
};
